module.exports = __webpack_public_path__ + "img/open-house-min.2a26b470.jpg";